import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
} from '@chakra-ui/react'
import React, { useRef } from 'react'
import { Button } from '../Buttons/Button'
import { FlexRow } from '../Containers'
import styles from './Modal.module.scss'

interface ModalProps {
  className?: string
  bodyClassName?: string
  isOpen: boolean
  onClose?: () => void
  title?: React.ReactNode
  subtitle?: string
  message: React.ReactNode
  onSubmit?: () => void
  closeText?: string
  submitText?: string
  submitDisabled?: boolean
  closeDisabled?: boolean
  hideButtons?: boolean
  danger?: boolean
  footer?: React.ReactNode
  footerClassName?: string
}

const Modal: React.FC<ModalProps> = ({
  className,
  bodyClassName,
  isOpen,
  onClose,
  title,
  subtitle,
  message,
  onSubmit,
  closeText = 'Close',
  submitText = 'Submit',
  submitDisabled = false,
  closeDisabled = false,
  danger,
  footer,
  footerClassName,
}) => {
  const cancelRef = useRef()

  return (
    <AlertDialog
      isOpen={isOpen}
      onClose={onClose}
      leastDestructiveRef={cancelRef}
    >
      <AlertDialogOverlay>
        <AlertDialogContent className={className}>
          {title && (
            <AlertDialogHeader>
              {title}
              {subtitle && (
                <span className={styles.subtitleText}>{subtitle}</span>
              )}
            </AlertDialogHeader>
          )}

          <AlertDialogBody className={bodyClassName}>{message}</AlertDialogBody>
          {footer === null
            ? null
            : footer || (
                <AlertDialogFooter className={footerClassName}>
                  <FlexRow gap="10px">
                    <Button
                      mode="default"
                      ref={cancelRef}
                      onClick={onClose}
                      disabled={closeDisabled}
                    >
                      {closeText}
                    </Button>

                    <Button
                      disabled={submitDisabled}
                      danger={danger}
                      onClick={() => {
                        onSubmit()
                      }}
                    >
                      {submitText}
                    </Button>
                  </FlexRow>
                </AlertDialogFooter>
              )}
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  )
}

export default Modal
